<template>
	<div class="flex flex-wrap justify-evenly">
		<div
			v-for="(sponsor, index) in logos"
			:key="index"
			class="w-40 h-40"
		>
			<NuxtImg
				:src="sponsor.src"
				:alt="sponsor.alt"
				height="160"
				width="160"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { Image } from '@/types/image'

const logos: Image[] = [
	{
		alt: 'Elizabeth Stampede Rodeo',
		src: '/images/logos/stampede_160x160.webp'
	},
	{
		alt: 'Elbert County Fair',
		src: '/images/logos/elbert_160x160.webp'
	},
	{
		alt: 'Elizabeth Education Foundation',
		src: '/images/logos/eef_160x160.webp'
	},
	{
		alt: 'Terolyn Horse Rescue',
		src: '/images/logos/terolyn_160x160.webp'
	},
	{
		alt: 'Elizabeth Community Rodeo',
		src: '/images/logos/ecr_160x160.webp'
	},
	{
		alt: 'Drifters Hearts of Hope',
		src: '/images/logos/dhoh_160x160.webp'
	}
]
</script>
